import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENContentTabFilterState from "@tCentro/Store/Reducer/CENContentTabFilterState";
import CenSelectedArticleTypeState from "@tCentro/Store/Reducer/CenSelectedArticleTypeState";
import { Draft } from "immer";
 
const initialState: CENContentTabFilterState = {
    selectedContentType:"0" ,
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/Article/SetSelectedContentType": (
        draft: Draft<CENContentTabFilterState>,
        action: { selectedContentType: any },
    ) => {
        draft.selectedContentType = action.selectedContentType;
    },
});